export function nextDirectionalIndex(rects, currentIndex, direction) {
  const current = rects[currentIndex];
  if (!current) return -1;
  const cx = current.left + current.width / 2;
  const cy = current.top + current.height / 2;
  let best = -1;
  let bestScore = Infinity;
  rects.forEach((rect, index) => {
    if (index === currentIndex) return;
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    const dx = x - cx; const dy = y - cy;
    const axis = direction === "left" ? -dx : direction === "right" ? dx : direction === "up" ? -dy : dy;
    if (axis <= 1) return;
    const cross = direction === "left" || direction === "right" ? Math.abs(dy) : Math.abs(dx);
    const score = axis + cross * 3;
    if (score < bestScore) { best = index; bestScore = score; }
  });
  return best;
}
